import Loader from './Loader'
import { useAppSelector } from '../store/hooks'
import { selectLoader } from '../store/slices/loaderSlice/loaderSlice'

export default function APILoader() {
  const isLoading = useAppSelector(selectLoader)
  return isLoading ? <Loader /> : <></>
}
